import {useEffect, useState} from 'react'

export default function useFetch(url) {
  const [state, setState] = useState(null)

  useEffect(() => {
    fetch(url)
      .then(res => res.json())
      .then(response => setState(JSON.stringify(response)))
  }, [])

  return [state, setState]
}
